var _desc, _defs, _rect, _rect2, _rect3, _circle, _circle2, _circle3, _rect4, _rect5, _rect6, _rect7, _rect8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFrontend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 360",
    role: "img",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Frontend Development") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Stylized browser and UI components.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bg",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0f3557"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#071e33"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 640,
    height: 360,
    fill: "url(#bg)",
    rx: 18
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 88,
    y: 56,
    width: 464,
    height: 248,
    rx: 14,
    fill: "#0a2a45",
    stroke: "#2d87be",
    strokeWidth: 2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 88,
    y: 56,
    width: 464,
    height: 34,
    rx: 14,
    fill: "#124c75"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 114,
    cy: 73,
    r: 6,
    fill: "#ffd700"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 134,
    cy: 73,
    r: 6,
    fill: "#73c6ff"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 154,
    cy: 73,
    r: 6,
    fill: "#5ad2ac"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 116,
    y: 112,
    width: 188,
    height: 30,
    rx: 8,
    fill: "#1f6ea2"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 320,
    y: 112,
    width: 204,
    height: 30,
    rx: 8,
    fill: "#174f77"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 116,
    y: 156,
    width: 140,
    height: 116,
    rx: 10,
    fill: "#153f60"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 272,
    y: 156,
    width: 252,
    height: 50,
    rx: 10,
    fill: "#1b5d8a"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 272,
    y: 222,
    width: 252,
    height: 50,
    rx: 10,
    fill: "#113a58"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrontend);
export default __webpack_public_path__ + "static/media/frontend.491166624cf89eeca08813aed78a0b91.svg";
export { ForwardRef as ReactComponent };